/**
 * Router — Hash-based SPA-Routing.
 *
 * WARUM Hash statt History-API: Funktioniert ohne Server-Konfiguration,
 * ideal für statisches PWA-Hosting (z.B. Vercel, Netlify, GitHub Pages).
 */
import { eventBus } from './eventBus.js';

class Router {
  constructor() {
    this.routes = new Map();
    this.currentRoute = null;
    this.currentParams = {};
  }

  register(path, screenFn) {
    this.routes.set(path, screenFn);
    return this;
  }

  start() {
    window.addEventListener('hashchange', () => this.resolve());
    this.resolve();   // initial render
  }

  navigate(path, params = {}) {
    this.currentParams = params;
    const newHash = '#' + path;
    if (window.location.hash === newHash) {
      this.resolve();   // gleiche Route → trotzdem neu rendern
    } else {
      window.location.hash = newHash;
    }
  }

  resolve() {
    const path = window.location.hash.slice(1) || '/';
    const screenFn = this.routes.get(path) || this.routes.get('/');

    if (!screenFn) {
      console.error(`[Router] No route for ${path}`);
      return;
    }

    this.currentRoute = path;
    eventBus.emit('route:before-change', { path });

    const root = document.getElementById('app');
    root.innerHTML = '';
    const node = screenFn(this.currentParams);
    if (node instanceof Node) root.appendChild(node);
    else if (typeof node === 'string') root.innerHTML = node;

    eventBus.emit('route:changed', { path });
  }
}

export const router = new Router();
